import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export interface Locale {
  lang: string;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class PurplTranslationLoaderService {
  constructor(private translate: TranslateService) { }

  public loadTranslations(...args: Locale[]): void {
    const locales = [...args];
    locales.forEach((locale) => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);
    });
  }

  setDefaultLanguage(locale: string = 'en'): void {
    this.translate.setDefaultLang(locale);
    this.translate.use(locale);
  }

  getTranslateInstance() {
    return this.translate;
  }
}
